import { cx } from "../../lib/cx.js";
/* empty css             */
import { jsx } from "react/jsx-runtime";
//#region src/components/Skeleton/Skeleton.tsx
var toCss = (value) => typeof value === "number" ? `${value}px` : value;
/**
* A placeholder shape shown while content loads, with a shimmer (none under reduced
* motion). Decorative: hidden from assistive technology, so the region that's loading
* should say so (`aria-busy`, and a status message).
*/
function Skeleton({ variant = "text", width, height, size, radius, className, style, ...rest }) {
	const resolved = {
		inlineSize: toCss(size ?? width),
		blockSize: toCss(size ?? height),
		borderRadius: toCss(radius),
		...style
	};
	return /* @__PURE__ */ jsx("span", {
		"aria-hidden": "true",
		className: cx("ds-skeleton", `ds-skeleton--${variant}`, className),
		style: resolved,
		...rest
	});
}
/** A paragraph's worth of text lines, the last one shorter. Decorative, like Skeleton. */
function SkeletonText({ lines = 3, className, ...rest }) {
	const count = Math.max(1, Math.floor(lines));
	return /* @__PURE__ */ jsx("span", {
		"aria-hidden": "true",
		className: cx("ds-skeleton-text", className),
		...rest,
		children: Array.from({ length: count }, (_, index) => /* @__PURE__ */ jsx(Skeleton, { className: cx("ds-skeleton-text__line", index === count - 1 && count > 1 && "ds-skeleton-text__line--last") }, index))
	});
}
//#endregion
export { Skeleton, SkeletonText };

//# sourceMappingURL=Skeleton.js.map